<div class="moneda-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-lavuro m-0 mb-1">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-capitalize">
          Compartir Información
        </span>
      </h3>

      <b *ngIf="noAgent">Acceso Público</b>
      <b *ngIf="agent">Agente: {{agent.name}}</b>
      <b *ngIf="client">Cliente: {{client.firstname}} {{client.lastname}}</b>
      <b *ngIf="task">Trabajo: {{task.title}} - {{task.category?.[0]?.name}}<br /></b>
      <b *ngIf="task?.deliverynote">Albarán: {{task.deliverynote?.serieAndNumber}}<br /></b>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="!link">
    <div class="col-12 mt-4">
      Generar enlace de acceso para: <br />

      <!-- no agent links -->
      <ul class="bg-light" *ngIf="noAgent">
        <li class="mt-1 p-1" style="position: relative;">
          Acceso a carga de Solicitudes<br>

          <button mat-icon-button type="button" (click)="generateGenericTaskRequestsLink()"
            style="position: absolute; bottom: 0px; right: 10px">
            <i class="material-icons">share</i>
          </button>
        </li>
      </ul>

      <!-- agent links -->
      <ul class="bg-light" *ngIf="agent">
        <li class="mt-1 p-1" style="position: relative;">
          Acceso a carga de Solicitudes<br>

          <button mat-icon-button type="button" (click)="generateTaskRequestsLink()"
            style="position: absolute; bottom: 0px; right: 10px">
            <i class="material-icons">share</i>
          </button>
        </li>
      </ul>

      <!-- client links -->
      <ul class="bg-light" *ngIf="client">
        <li class="mt-1 p-1" style="position: relative;">
          Trabajos por fecha<br>
          desde: <input type="date" class="filter small" [(ngModel)]="taskByDate.scheduledStart"
            (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />
          hasta: <input type="date" class="filter small" [(ngModel)]="taskByDate.scheduledEnd"
            (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />

          <button mat-icon-button type="button" (click)="generateTaskByDateLink()"
            style="position: absolute; bottom: 0px; right: 10px">
            <i class="material-icons">share</i>
          </button>
        </li>
      </ul>

      <!-- task links -->
      <ul class="bg-light" *ngIf="task">

        <li class="mt-1 p-1" style="position: relative;" *ngIf="task.deliverynote">
          Acceso a Albarán

          <button mat-icon-button type="button" (click)="generateDeliveryNoteLink()"
            style="position: absolute; bottom: 0px; right: 10px">
            <i class="material-icons">share</i>
          </button>
        </li>

        <li class="mt-1 p-1" style="position: relative;">
          Este Trabajo y todos sus agregados

          <button mat-icon-button type="button" (click)="generateSingleTaskLink()"
            style="position: absolute; bottom: 0px; right: 10px">
            <i class="material-icons">share</i>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <ng-container *ngIf="link">

    <div class="row">
      <div class="col-12 mt-4">
        Este es el enlace generado: <br />
        <p class="p-4 bg-light">
          Copia este enlace y envíaselo a las personas con las que quieras compartir esta Información.
          Guárdalo también si lo deseas para poder usarlo en otro momento.<br><br>

          <button mat-icon-button type="button" class="pull-right" (click)="copyLink()">
            <i class="material-icons">content_copy</i>
          </button>

          <a [href]="link" target="_blank" class="mt-1">{{link}}</a>
        </p>
      </div>
    </div>
  </ng-container>
</div>